import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import dayjs from 'dayjs';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

export function ArbeitsbereichStationInfo({
  station,
}: {
  station: ArbeitsbereichStation;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <div className="flex flex-col md:flex-row gap-2 items-start md:items-center">
          <div className="flex items-center gap-2">
            <div className="text-sm">
              <FontAwesomeIcon
                icon={faCircle}
                color={station.arbeitsbereich.getBorderColor()}
                size="xs"
              />
            </div>
            <div className="font-bold">{station.arbeitsbereich.name}</div>
          </div>
        </div>
        {station.lernziele && station.lernziele.length > 0 && (
          <div className="text-sm text-neutrals-700 line-clamp-3">
            {station.lernziele}
          </div>
        )}
      </div>
      <div className="flex flex-col items-start md:flex-row gap-2 md:gap-4 md:items-center text-neutrals-700 text-sm">
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon icon={faCalendarRange} />
          {dayjs(station.von).format('DD.MM.YYYY') +
            ' - ' +
            dayjs(station.bis).format('DD.MM.YYYY')}
        </div>
        {station.abteilungsleiter && (
          <div className="flex gap-1 items-center">
            <FontAwesomeIcon icon={faUser} />
            {station.abteilungsleiter.getName()}
          </div>
        )}
        <Location
          className="text-sm"
          standort={station.arbeitsbereich.standort}
        />
      </div>
    </div>
  );
}
